// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"78684956","290":"f618b7e2","400":"f244e69b","716":"2b97facf"}[chunkId] + ".chunk.js";
};